import { Form } from "@unform/web";

import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;

export const FormWrapper = styled(Form)`
  display: grid !important;
  grid-template-columns: 2fr 2fr;
  gap: 10px;
  align-items: flex-end !important;
`;

export const Table = styled.div`
  width: 100%;
  margin: 0 auto;

  svg {
    cursor: pointer;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
